import { EnumDto, ManufacturingEventCategoryState } from '../types'
import Vue from 'vue'
import { GetterTree, MutationTree, ActionTree } from 'vuex'
import ApiResponse from 'models/apiResponse'
import ProblemDetails from 'models/problemDetails'


const state: ManufacturingEventCategoryState = {
    list: Array<EnumDto>(),
    timestampMS: null
}

const getters: GetterTree<ManufacturingEventCategoryState, any> = {
    getManufacturingEventCategoryList: state => () => {
        return state.list;
    }
}

const mutations: MutationTree<ManufacturingEventCategoryState> = {
    setManufacturingEventCategoryList(state, data) {
        //reset list first.
        state.list = [];
        data.forEach((manufacturingEventCategory: EnumDto, index) => {
            Vue.set(state.list, index, manufacturingEventCategory);
        });
    },
    setManufacturingEventCategoryTimestamp(state) {
        // 1 Hour
        const expiration = 60 * 60 * 1000;
        state.timestampMS = new Date().getTime() + expiration;
    }
}

const actions: ActionTree<ManufacturingEventCategoryState, any> = {
    async fetchManufacturingEventCategories({ commit, state, dispatch }) {
        if (state.list.length == 0 || (state.timestampMS && new Date().getTime() > state.timestampMS)) {
            await dispatch('refreshManufacturingEventCategories');
        }
    },
    async refreshManufacturingEventCategories({ commit, state }) {
        const url = Vue.IdentityConfig.manufacturingApiUri + "/events/category";
        const options: RequestInit = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: "no-cache"
        };
        await fetch(url, options)
            .then(response => {
                if (!response.ok)
                    throw response;
                return response.json() as Promise<Array<EnumDto>>
            })
            .then(async data => {
                commit('setManufacturingEventCategoryList', data);
                commit('setManufacturingEventCategoryTimestamp');
            })
            .catch(error => {
                if (error instanceof Response) {
                    error.json().then((data: ProblemDetails) => {
                        ProblemDetails.ErrorMessages(data).forEach(e => {
                            Vue.Logger.LogError(e);
                        })
                    })
                } else {
                    Vue.Logger.LogError(error);
                }
            });
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}